import React, { Component } from 'react';
import axios from 'axios';
import { uAPI } from '../config/Config';
import './assets/email-log.css';

class EmailLog extends Component {
  state = {
    rows: [],
    summary: { total: 0, success: 0, failed: 0, pending: 0, processing: 0, retry: 0 },
    search: '',
    status: '',
    page: 1,
    pages: 1,
    loading: true,
    retrying: null,
    message: ''
  };

  componentDidMount() {
    this.load();
    this.loadSummary();
  }

  load = async (page = this.state.page) => {
    this.setState({ loading: true });
    try {
      const response = await axios.get(uAPI + '/api/v1/email-logs', {
        params: { search: this.state.search, status: this.state.status, page, limit: 20 }
      });
      const result = response.data && response.data.results ? response.data.results : {};
      this.setState({ rows: result.data || [], page: result.page || page, pages: result.pages || 1, loading: false });
    } catch (error) {
      this.setState({ loading: false, message: 'Gagal mengambil log email.' });
    }
  };

  loadSummary = async () => {
    try {
      const response = await axios.get(uAPI + '/api/v1/email-logs/summary');
      this.setState({ summary: response.data.results || this.state.summary });
    } catch (error) {
      // The table remains usable when statistics fail.
    }
  };

  retry = async (id) => {
    this.setState({ retrying: id, message: '' });
    try {
      const response = await axios.post(uAPI + '/api/v1/email-logs/' + id + '/retry');
      this.setState({ retrying: null, message: response.data.message || 'Email dimasukkan ke antrean.' });
      setTimeout(() => { this.load(); this.loadSummary(); }, 800);
    } catch (error) {
      this.setState({ retrying: null, message: 'Retry email gagal.' });
    }
  };

  retryAll = async () => {
    this.setState({ retrying: 'all', message: '' });
    try {
      const response = await axios.post(uAPI + '/api/v1/email-logs/retry-all');
      this.setState({ retrying: null, message: response.data.message || 'Email gagal dimasukkan ke antrean retry.' });
      setTimeout(() => { this.load(); this.loadSummary(); }, 800);
    } catch (error) {
      this.setState({ retrying: null, message: 'Retry semua email gagal.' });
    }
  };

  badge = (status) => <span className={'email-status email-status-' + String(status || '').toLowerCase()}>{status}</span>;

  render() {
    const { summary, rows, loading, search, status, page, pages, message, retrying } = this.state;
    return (
      <div className="email-page">
        <div className="email-hero">
          <div>
            <div className="email-kicker">MONITORING</div>
            <h1>Email Delivery Center</h1>
            <p>Pantau email otomatis dari proses import peserta, lihat error, dan lakukan retry tanpa mengulang import Excel.</p>
          </div>
          <button className="email-retry-all" onClick={this.retryAll} disabled={retrying === 'all'}>
            {retrying === 'all' ? 'Memproses...' : 'Retry Email Gagal'}
          </button>
        </div>

        <div className="email-stats">
          <div className="email-stat"><span>Total</span><strong>{summary.total}</strong><small>Semua email</small></div>
          <div className="email-stat success"><span>Terkirim</span><strong>{summary.success}</strong><small>SUCCESS</small></div>
          <div className="email-stat warning"><span>Pending</span><strong>{summary.pending + summary.processing + summary.retry}</strong><small>Dalam antrean</small></div>
          <div className="email-stat danger"><span>Gagal</span><strong>{summary.failed}</strong><small>Perlu perhatian</small></div>
        </div>

        <div className="email-panel">
          <div className="email-toolbar">
            <input value={search} onChange={e => this.setState({ search: e.target.value })} onKeyDown={e => e.key === 'Enter' && this.load(1)} placeholder="Cari email, nama, atau nomor peserta..." />
            <select value={status} onChange={e => { this.setState({ status: e.target.value }); setTimeout(() => this.load(1), 0); }}>
              <option value="">Semua status</option>
              <option value="SUCCESS">SUCCESS</option>
              <option value="PENDING">PENDING</option>
              <option value="PROCESSING">PROCESSING</option>
              <option value="FAILED">FAILED</option>
              <option value="RETRY">RETRY</option>
            </select>
            <button onClick={() => { this.load(1); this.loadSummary(); }}>Refresh</button>
          </div>
          {message && <div className="email-message">{message}</div>}

          <div className="email-table-wrap">
            <table className="email-table">
              <thead><tr><th>No</th><th>Peserta</th><th>Email</th><th>Status</th><th>Retry</th><th>Waktu</th><th>Error</th><th>Aksi</th></tr></thead>
              <tbody>
                {loading ? <tr><td colSpan="8" className="email-empty">Memuat log...</td></tr> : rows.length === 0 ? <tr><td colSpan="8" className="email-empty">Belum ada log email.</td></tr> : rows.map((row, i) => (
                  <tr key={row.id}>
                    <td>{((page - 1) * 20) + i + 1}</td>
                    <td><strong>{row.nama || '-'}</strong><small>{row.patient_id || '-'}</small></td>
                    <td>{row.email}</td>
                    <td>{this.badge(row.status)}</td>
                    <td>{row.retry_count || 0}</td>
                    <td>{row.sent_at || row.created_at || '-'}</td>
                    <td className="email-error">{row.error_message || '-'}</td>
                    <td>{row.status !== 'SUCCESS' ? <button className="retry-btn" disabled={retrying === row.id} onClick={() => this.retry(row.id)}>{retrying === row.id ? '...' : 'Retry'}</button> : <span className="done-mark">✓</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="email-pagination">
            <button disabled={page <= 1} onClick={() => this.load(page - 1)}>‹</button>
            <span>Halaman {page} / {pages}</span>
            <button disabled={page >= pages} onClick={() => this.load(page + 1)}>›</button>
          </div>
        </div>
      </div>
    );
  }
}

export default EmailLog;
